module.exports = __webpack_public_path__ + "static/media/arrow_dn.0f1f3bcd.svg";